import GiftboxGame from './GiftboxGame';
import GiftboxGame2 from './GiftboxGame2';
import GiftboxIntro from './GiftboxIntro';
import GiftboxOutro from './GiftboxOutro';
import MissionIntro from './MissionIntro';

export default [GiftboxIntro, MissionIntro, GiftboxGame2, GiftboxOutro];
